<nf-grid-wrapper>
  <nf-grid-wrapper-header-left>
    <h2 class="title">Request Details</h2>
  </nf-grid-wrapper-header-left>
  <ng-grid-wrapper-header-right>
    <button
      id="clear-all-filters-button"
      nf-icon-button="secondary"
      ngbTooltip="Clear Filters"
      icon="filter-remove"
      (click)="clearFilters()"
      class="filter-button"
      [disabled]="!clearFiltersEnabled"
      placement="bottom-right"
    >
      Clear All Filters
    </button>
    <hs-applied-filter-counts
      [filterCount]="filterCount"
    ></hs-applied-filter-counts>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content>
    <nf-table-layout
      *nfLoader="isLoading"
      [autoResizeGrid]="false"
      [gridOptions]="approvalDetailGridOptions"
      [data]="data"
      hideTitle
      hideSearch
      hideClearAll
    >
    </nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
